import { create } from 'zustand';
import { api, ApiError } from '../api/client';
import type { User } from '../api/types';

export type AuthStatus = 'unknown' | 'anonymous' | 'authenticated';

interface AuthState {
  me: User | null;
  status: AuthStatus;
  bootstrap: () => Promise<void>;
  login: (username: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  me: null,
  status: 'unknown',

  async bootstrap() {
    try {
      await api.get('/api/health');
    } catch { /* health failure is not fatal for csrf seeding */ }
    try {
      const me = await api.get<User>('/api/auth/me');
      set({ me, status: 'authenticated' });
    } catch (e) {
      if (e instanceof ApiError && e.status === 401) {
        set({ me: null, status: 'anonymous' });
      } else {
        set({ me: null, status: 'anonymous' });
      }
    }
  },

  async login(username, password) {
    await api.post('/api/auth/login', { username, password });
    await get().bootstrap();
  },

  async logout() {
    try { await api.post('/api/auth/logout'); } catch { /* idempotent */ }
    set({ me: null, status: 'anonymous' });
  },
}));
